import React from 'react';

import InfoTooltip from './InfoTooltip';

export default function getInfoTooltip(helpTexts, textKey, section, placement) {
  const helpText = helpTexts[section] && helpTexts[section][textKey];
  if (!helpText) {
    return null;
  }
  const target = `${section}-${textKey}`;
  return (
    <InfoTooltip target={target} placement={placement}>
      {helpText}
    </InfoTooltip>
  );
}
